window.addEventListener('DOMContentLoaded', () => {
	let cards = document.querySelectorAll('.risk-management .cards .card')
	let thumbnails = document.querySelectorAll(
		'.risk-management .keen-slider__slide'
	)
	let sliderElement = document.querySelector('.risk-management .keen-slider')
	let speed = 5000
	let timeout
	let mouseOver = false

	function clearNextTimeout() {
		clearTimeout(timeout)
	}

	function nextTimeout() {
		clearTimeout(timeout)
		if (mouseOver) return
		timeout = setTimeout(() => {
			let index = parseInt(
				document.querySelector('.risk-management .keen-slider__slide.active')
					.dataset.index
			)
			index++
			goTo(index)
			nextTimeout()
		}, speed)
	}

	function updateClasses(index) {
		cards.forEach(card => {
			card.classList.remove('active')
		})
		thumbnails.forEach(thumb => {
			thumb.classList.remove('active')
		})
		cards[index].classList.add('active')
		thumbnails[index].classList.add('active')
	}

	function goTo(index) {
		if (index >= cards.length) {
			index = 0
		} else if (index < 0) {
			index = cards.length - 1
		}

		let diff = Math.ceil(index - slider.options.slides.perView / 2)

		if (diff < slider.track.details.minIdx) {
			diff = slider.track.details.minIdx
		} else if (diff > slider.track.details.maxIdx) {
			diff = slider.track.details.maxIdx
		}
		slider.moveToIdx(diff)
		updateClasses(index)
	}

	var slider = new KeenSlider(
		sliderElement,
		{
			breakpoints: {
				'(min-width: 512px)': {
					slides: {
						perView: 4,
						spacing: 0,
					},
				},
				'(min-width: 768px)': {
					slides: {
						perView: 3,
						spacing: 0,
					},
				},
				'(min-width: 992px)': {
					slides: {
						perView: 4,
						spacing: 0,
					},
				},
				'(min-width: 1200px)': {
					slides: {
						perView: 5,
						spacing: 0,
					},
				},
				'(min-width: 1536px)': {
					slides: {
						perView: 7,
						spacing: 0,
					},
				},
			},
			slides: {
				perView: 3,
				spacing: 0,
			},
			defaultAnimation: {
				duration: 800,
			},
			drag: false,
		},
		[
			slider => {
				thumbnails.forEach(thumb => {
					thumb.addEventListener('click', () => {
						clearNextTimeout()
						nextTimeout()
						let index = parseInt(thumb.dataset.index)
						goTo(index)
					})
				})

				slider.container.addEventListener('mouseover', () => {
					mouseOver = true
					clearNextTimeout()
				})
				slider.container.addEventListener('mouseout', () => {
					mouseOver = false
					nextTimeout()
				})
			},
		]
	)

	let observer = new IntersectionObserver(entries => {
		entries.forEach(entry => {
			if (entry.isIntersecting) {
				nextTimeout()
			} else {
				clearNextTimeout()
			}
		})
	})

	observer.observe(sliderElement)
})
